import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import LoanInfoService from '../../../../service/LoanInfo';
import PageTop from '../../../components/pageTop/PageTop';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

interface Image {
  idx: string;
  img: string;
  description: string;
}

function SaveImages() {
  const [images, setImages] = useState<Image[]>([]);
  const [selectedImages, setSelectedImages] = useState<Image[]>([]);
  const [pdfTitle, setPdfTitle] = useState('');

  const params = new URLSearchParams(window.location.search);
  const iidx = params.get('iidx');

  const toggleImageSelection = (img: Image) => {
    setSelectedImages((prev) => {
      const exists = prev.some((i) => i.idx === img.idx);
      if (exists) {
        return prev.filter((i) => i.idx !== img.idx);
      } else {
        return [...prev, img];
      }
    });
  };

  const toggleAll = () => {
    if (selectedImages.length === images.length) {
      setSelectedImages([]);
    } else {
      setSelectedImages(images);
    }
  };

  const saveAsPDF = async () => {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    for (let i = 0; i < selectedImages.length; i++) {
      const imgEl = document.getElementById(`pdf-img-${selectedImages[i].idx}`);
      if (!imgEl) continue;

      const canvas = await html2canvas(imgEl as HTMLElement, { useCORS: true });
      const imgData = canvas.toDataURL('image/png');

      const imgProps = pdf.getImageProperties(imgData);
      const imgRatio = imgProps.width / imgProps.height;
      const pageRatio = pdfWidth / pdfHeight;

      let imgW = pdfWidth;
      let imgH = pdfHeight;

      if (imgRatio > pageRatio) {
        imgH = imgW / imgRatio;
      } else {
        imgW = imgH * imgRatio;
      }

      if (i !== 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', (pdfWidth - imgW) / 2, 0, imgW, imgH);
    }
    pdf.save(`${pdfTitle ? pdfTitle : '사진파일'}.pdf`);
  };

  const getData = async (iidx: number) => {
    try {
      // setLoading(true);
      const res = await LoanInfoService.imageDetail(iidx);
      setImages(res.data.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (iidx) {
      getData(Number(iidx));
    }
  }, [iidx]);

  return (
    <Container>
      <PageTop logo />
      <Content>
        <Inner>
          <Images>
            <ImagesHeader>
              <SelectButton onClick={toggleAll}>
                <img
                  src={
                    selectedImages.length === images.length
                      ? '/assets/images/check/check-blue-on.svg'
                      : '/assets/images/check/check-blue-off.svg'
                  }
                  alt=""
                />
                <span>전체 선택</span>
              </SelectButton>
            </ImagesHeader>
            <ImagesRow>
              {images.map((item) => (
                <ImageItem
                  key={item.idx}
                  onClick={() => toggleImageSelection(item)}
                >
                  <img
                    src={item.img}
                    alt=""
                    height={120}
                    style={{ objectFit: 'contain' }}
                  />
                  <SelectButton>
                    <img
                      src={
                        selectedImages.some((i) => i.idx === item.idx)
                          ? '/assets/images/check/check-blue-on.svg'
                          : '/assets/images/check/check-blue-off.svg'
                      }
                      alt=""
                    />
                    <span>사진 선택</span>
                  </SelectButton>
                </ImageItem>
              ))}
            </ImagesRow>
          </Images>
          <SaveToolBar>
            <TitleInput
              placeholder="파일명을 입력해주세요"
              value={pdfTitle}
              onChange={(e) => setPdfTitle(e.target.value)}
            />
            {/* <SaveButton> */}
            <SaveButton onClick={saveAsPDF}>
              <img src="/assets/images/icon/save-white.svg" alt="" />
              <span>PDF 저장</span>
            </SaveButton>
          </SaveToolBar>
          <PDFPreviewArea id="pdf-preview">
            {selectedImages.map((img) => (
              // <img key={img.idx} src={img.img} alt="" />
              <div key={img.idx} id={`pdf-img-${img.idx}`}>
                <img src={img.img} alt="" crossOrigin="anonymous" />
              </div>
              // <img key={img.idx} src={img.img} alt="" crossOrigin="anonymous" />
            ))}
          </PDFPreviewArea>
        </Inner>
      </Content>
    </Container>
  );
}

export default SaveImages;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow-x: hidden;
`;

const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Images = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

const ImagesHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const SelectButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
  justify-content: center;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const ImagesRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: nowrap;
  overflow-x: auto;

  /* 스크롤바 숨기기 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ImageItem = styled.div`
  /* height: 120px; */
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  cursor: pointer;
`;

const SaveToolBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 16px;
  gap: 8px;
  background-color: #222222;
`;

const TitleInput = styled.input`
  flex: 1;
  min-width: 0;
  background-color: transparent;
  border: none;
  outline: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #fff;

  &::placeholder {
    color: #989ba2;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  background-color: transparent;
  cursor: pointer;
  white-space: nowrap;
  align-items: center;

  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
    color: #fff;
  }
`;

const PDFPreviewArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;

  div {
    width: 100%;
  }
  img {
    object-fit: contain;
    width: 100%;
  }
`;

const SlideButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
